import React, {useEffect, useState} from "react";
import axios from "axios";
import {config} from "../../../../Helpers/env";
import {errorMessages, logoutErrorMessage} from "../../../../Helpers/ErrorMessages";
import {formatDate} from "../../../Utils/ConvertDate";
import ObGynSidebar from "../../Utils/ObGynSidebar";
import PageTitle from "../../../Utils/smsTitle";
import {SubHeader} from "../../../../Containers/SubHeader";
import CustomDialog from "../../../Utils/Dialogs/CustomDialog";
import MainSnackbar from "../../../Utils/Snackbar/SmsSnackbar";
import ObGynPatientInfo from "../../Utils/ObGynPatientInfo";
import {
    FinishedStatus,
    P,
    PendingStatus,
    StyledIcon,
    StyledRemoveIcon
} from "../../../DoctorsModule/doctorStyles";
import {CenteredContainer} from "../../../Utils/styledComponents";
import {LoadingGif} from "../../../Utils/Loader";
import {CollapsibleList, DataCell, ModuleTable} from "../../../Utils/Lists/CollapsibleList";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import TableRow from "@material-ui/core/TableRow";
import {bindActionCreators} from "redux";
import * as snackbarActions from "../../../../actions/snackbarActions";
import {connect} from "react-redux";

import {AddGynProcedure} from "./AddProcedure";
import TextField from "../../../Utils/FormInputs/TextField";
import DeleteDialog from "../../../Utils/Dialogs/DeleteDialog";

const headData = [{item:'Procedure', isRequired:true}, {item:'Quantity', isRequired:false},
    {item:'Status', isRequired:false}, {item:'Action', isRequired:false}]
const GynAndObsPreviousProcedure = ({actions, snackbars,match:{params}}) => {
    const {patient_number, visit_id,patient_type} = params;
    const user = JSON.parse(sessionStorage.getItem('user'));
    const userObj = !user ? {} : user;
    const token = !userObj.token ? [] : userObj.token;
    const _token = !token[1] ? {} : token[1];
    const doctor_name = `${!_token.first_name ? "" : _token.first_name} ${!_token.last_name ? "" : _token.last_name}`;

    const [previousProcedures, setPreviousProcedures] = useState([])
    const [status, setStatus] = useState('idle')
    const [openIsDone, setOpenIsDone] = useState(false)
    const [item, setItem] = useState({})
    const [isDone, setIsDone] = useState('idle')
    const [openDialog, setOpenDialog] = useState(false)
    const [isSubmitted, setIsSubmitted] = useState('idle');
    const [isBlocking, setIsBlocking] = useState(false)
    const [isBlockDialog, setIsBlockDialog] = useState(false)
    const [isEditing, setIsEditing] = useState('idle')
    const [openDelete, setOpenDelete] = useState(false)
    const [deleteData, setDeleteData] = useState({})


    const isIncomplete = isDone === 'pending'
    const isComplete = isDone === 'success'

    const isResolved = isSubmitted === 'resolved'
    const isEditResolved = isEditing === 'resolved'

    useEffect(() => {
        const formData = new FormData();
        formData.append('visit_id', visit_id);
        setStatus('pending')
        axios.post(`${config.smsUrl}/cdoctor/get_previous_procedure_by_visit_id`, formData).then(res => {
            const resp = res.data;
            const data = !resp ? {} : resp;
            const arr = data.procedure ? data.procedure : []
            const services = groupByData(arr)
            const prods = services.map(item=>({...item,open:true}))
            setPreviousProcedures(prods);
            setStatus('success')
        }).catch(error => {
            logoutErrorMessage(error, null, actions)
            setStatus('error')
        });
    }, [isComplete, isResolved, isEditResolved])


    const groupByData = (arr=[]) =>{
        let result = []
        let knowledge = {}
        arr.forEach(item =>{
            let id = formatDate(item.date_created);
            if(id in knowledge){
                result[knowledge[id]].services.push(item)
            }else {
                knowledge[id] = result.length
                result.push({
                    id: id,
                    date:id,
                    doctor_name:`${item.doctor_firstname ? item.doctor_firstname:''} ${item.doctor_lastname ? item.doctor_lastname : ''}`,
                    services: [item]
                })

            }
        })
        return result
    }


    const handleOpen = (id) =>{
        const itemsArr = previousProcedures.map((item)=>{
            if(item.id === id){
                return {...item,open:!item.open}
            }else{
                return item
            }
        })
        setPreviousProcedures(itemsArr)
    }

    const handleChangeValue = (event, parentIdx,childIdx) =>{
        const arr = previousProcedures.map((item, pIndex)=>{
            if (parentIdx === pIndex){
                return {
                    ...item,
                    services: item.services.map((service, cIndex)=>{
                        if (childIdx === cIndex){
                            return {
                                ...service,
                                quantity:event.target.value
                            }
                        }
                        return service
                    })
                }
            }
            return item

        })
        setPreviousProcedures(arr)
    }

    const handleOpenEdit = (parentIdx,childIdx, editType) =>{
        const arr = previousProcedures.map((item, pIndex)=>{
            if (parentIdx === pIndex){
                return {
                    ...item,
                    services: item.services.map((service, cIndex)=>{
                        if (childIdx === cIndex){
                            return {
                                ...service,
                                isEdit:editType
                            }
                        }
                        return service
                    })
                }
            }
            return item

        })
        setPreviousProcedures(arr)
    }

    const handleEditProcedure = (item, pIdx=0, cIndx=0) => {
        const params = {
            visit_id: +visit_id,
            result_type: 1,
           ...item
        }
        setIsEditing('pending');
        axios.post(`${config.smsUrl}/cdoctor/update_procedure`, {...params}).then(() => {
            actions.snackbarActions.snackSuccess(`Procedure updated successfully`);
            setIsEditing('resolved');
            handleOpenEdit(pIdx, cIndx, false)
            setOpenDelete(false)
        }).catch(err => {
            errorMessages(err, null, actions)
            setIsEditing('rejected');
        })

    };

    const handleOpenDone = (row) =>{
        setOpenIsDone(true)
        setItem(row)
    }

    const handleCloseDone = () =>{
        setOpenIsDone(false)
    }

    const markAsDone = () =>{
        setIsDone('pending')
        axios.get(`${config.smsUrl}/cbilling/update_inpatient_service_bill`, {params:{bill_id:item.bill_id}}).then(res => {
            actions.snackbarActions.snackSuccess('Procedure completed successfully')
            setIsDone('success')
            setOpenIsDone(false)
        }).catch(error => {
            errorMessages(error, null, actions)
            setIsDone('error')
        });
    }

    const isLoading = status === 'pending'
    const isSuccess = status === 'success'
    const isError = status === 'error'

    const handleCloseDialog = () =>{
        if(isBlocking){
            setIsBlockDialog(true)
        }else{
            setIsBlockDialog(false)
            setIsBlocking(false)
            setOpenDialog(false);
        }
    }

    const isPendingEdit = isEditing === 'pending'

    const closeSnackbar = () => {
        actions.snackbarActions.hideSnackbar()
    };



    const {openBar, type, message} = snackbars;

    const buttons = (
        <>
            <button type='button' onClick={markAsDone} disabled={isIncomplete}
                    className='btn btn-sm small-btn sms-info-btn mr-3'>{isIncomplete ? 'Marking...':'Yes'}</button>
            <button type='button' onClick={handleCloseDone} className='btn btn-sm small-btn sms-gray-btn mr-3'>Cancel</button>
        </>
    )

    const deleteButtons = (
        <>
            <button type='button' onClick={()=>handleEditProcedure(deleteData)} disabled={isPendingEdit}
                    className='btn btn-sm small-btn sms-btn-dismiss mr-3'>{isPendingEdit ? 'Deleting...':'Delete'}</button>
            <button type='button' onClick={()=>setOpenDelete(false)} className='btn btn-sm small-btn sms-gray-btn mr-3'>Cancel</button>
        </>
    )
    return (
        <div className='journals'>
            <PageTitle title="Procedures"/>
            <SubHeader
                title="Doctor"
                subTitle="Procedures"
                doctor_name={doctor_name}
            >
                <div className="header-icon-margin-right-zero"><img src="/images/antenatal-blue.png"
                                                                    className="icon-resize surgery-icon-tabs ante-natal-green"/>
                </div>
            </SubHeader>
            <CustomDialog title='Add procedure' open={openDialog} handleClose={handleCloseDialog} maxWidth='md'>
                <AddGynProcedure {...{actions, visit_id,isSubmitted, setIsSubmitted, setOpenDialog,
                    isBlocking, setIsBlocking,isBlockDialog, setIsBlockDialog}}/>
            </CustomDialog>

            <DeleteDialog handleClose={()=>setOpenDelete(false)} title='Delete Procedure'
                          openDialog={openDelete} message='delete' text='procedure'>
                {deleteButtons}
            </DeleteDialog>

            <CustomDialog open={openIsDone} title={`Mark ${item?.procedure_name} as done`} handleClose={handleCloseDone} buttons={buttons}>
                <p style={{textAlign:'center', margin:0}}>Are you sure you want to mark <strong>{item?.procedure_name}?</strong> as done</p>
            </CustomDialog>
            <MainSnackbar open={openBar} handleCloseBar={closeSnackbar} variant={type} message={message}/>
            <ObGynSidebar patient_number={patient_number} visit_id={visit_id} patient_type={patient_type}>
                <ObGynPatientInfo patient_number={patient_number} visit_id={visit_id} />
                <div style={{padding: '12px 16px'}}>
                    <button onClick={()=>setOpenDialog(true)}  type='button' className='btn btn-sm sms-info-btn mb-2'>Add Procedure</button>
                    {isLoading ? <CenteredContainer>
                        <LoadingGif/>
                    </CenteredContainer> : null}
                    {isSuccess ? previousProcedures.length > 0 ? previousProcedures.map((item, idx)=>{
                        const payStatus =  item.services.some(dt=>dt.pay_status === 0)
                        return(
                            <CollapsibleList key={item.id} open={item.open} name={item.date} handleOpen={()=>handleOpen(item.id)}>
                                <ModuleTable headData={headData}>
                                    {item.services.map((row, index) => {
                                        const isPending = row.item_status === 'Pending' || row.item_status === null;
                                        const isFinished = row.item_status === 'Done';
                                        const isPaid = row.pay_status === 1 ||  row.pay_status === 3
                                        const isUnpaid = row.pay_status === 0 || row.pay_status === 3

                                        const editData = {
                                                procedure_id: row.procedure_id,
                                                procedure_payment_id: row.procedure_payment_id,
                                                invoice_no: row.invoice_no ?? '',
                                                bill_type:2,
                                                quantity: +row.quantity,
                                                rate: row.rate,
                                                bill_details:{
                                                    service_id: row.service_id,
                                                    quantity: +row.quantity,
                                                    rate: row.rate,
                                                    bill_id:row.bill_id,
                                                    invoice_no: row.invoice_no ?? '',
                                                }
                                        }

                                        const saveButtons = (
                                            <>
                                                <button
                                                    type="submit"
                                                    className="btn btn-sm sms-btn small-btn mr-3"
                                                    onClick={() => handleEditProcedure({
                                                        invoices_added:[editData], invoices_removed:[]
                                                    }, idx, index)}
                                                    style={{ marginTop: "5px", marginBottom: "5px" }}
                                                >
                                                    {isPendingEdit ? "Saving..." : "Save"}
                                                </button>
                                                <button
                                                    type="submit"
                                                    className="btn btn-sm sms-gray-btn small-btn"
                                                    onClick={() => handleOpenEdit(idx,index, false)}
                                                    style={{ marginTop: "5px", marginBottom: "5px" }}
                                                >
                                                    Cancel
                                                </button>
                                            </>
                                        );

                                        const updateButtons =row.isEdit ? saveButtons :  (
                                            <React.Fragment>
                                                <Tooltip title='Edit Request'>
                                                    <IconButton onClick={() => handleOpenEdit(idx, index, true)}>
                                                        <StyledIcon/>
                                                    </IconButton>
                                                </Tooltip>
                                                <Tooltip title='Delete Request'>
                                                    <IconButton onClick={() => {
                                                        setOpenDelete(true)
                                                        setDeleteData({
                                                            invoices_added: [], invoices_removed: [editData]
                                                        })
                                                    }}>
                                                        <StyledRemoveIcon/>
                                                    </IconButton>
                                                </Tooltip>
                                            </React.Fragment>
                                        )

                                        const completeButton = (
                                            <button type='button' onClick={() => handleOpenDone(row)}
                                                    className='btn btn-sm small-btn mr-3 sms-info-btn'>Mark as done</button>
                                        )

                                        return (
                                            <TableRow
                                                key={index}
                                            >
                                                <DataCell>
                                                    {row.procedure_name}
                                                </DataCell>
                                                <DataCell>
                                                    {row.isEdit ?
                                                        <TextField  id='service_quantity'
                                                                   value={row.quantity} name='quantity'
                                                                   data-test="service_quantity"
                                                                   onChange={e => handleChangeValue(e,idx ,index)}/>:
                                                        row.quantity}
                                                </DataCell>
                                                <DataCell>{isPending ? <PendingStatus>{row.item_status ? row.item_status : 'Pending'}</PendingStatus>:isFinished ? <FinishedStatus>{row.item_status}</FinishedStatus>: null}</DataCell>
                                                <DataCell>
                                                    {isPending && isPaid && !row.isEdit ? completeButton : null}
                                                    {isPending && isUnpaid ? updateButtons :  null}
                                                </DataCell>
                                            </TableRow>
                                        )})}
                                </ModuleTable>
                            </CollapsibleList>
                        )
                    }) : <CenteredContainer>
                        <P>No procedures added for patient, click the add procedure button to add a procedure</P>
                    </CenteredContainer>:null}
                    {isError ? <CenteredContainer>
                        <P>An error occurred on the server</P>
                    </CenteredContainer>:null}
                </div>
            </ObGynSidebar>
        </div>
    )
}

function mapStateToProps(state) {
    return {
        snackbars: state.snackbar
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            snackbarActions: bindActionCreators(snackbarActions, dispatch)
        }
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(GynAndObsPreviousProcedure);